<template>
  <div class="banner-list">
    <div class="glide-container">
      <div
        class="glide__track"
        data-glide-el="track">
        <div class="glide__slides">
          <router-link
            v-for="banner in banners"
            :key="`slide-item-${banner.id}`"
            :to="banner.url"
            class="banner-list__item glide__slide">
            <img
              :src="`/storage${banner.picture_banner}`"
              height="176"
              width="100%"
              alt=""
              class="banner-list__item-img">
          </router-link>
        </div>
      </div>
    </div>
    <template v-if="!isSingle">
      <div class="banner-list__bullets glide__bullets">
        <button
          v-for="(item, index) in banners"
          :key="`bullet-item-${item.id}`"
          :class="{ 'banner-list__bullets-item--active': index === sliderIndex }"
          class="banner-list__bullets-item glide__bullet transition--color-bg" />
      </div>
      <div class="banner-list__controls">
        <button
          class="banner-list__controls-item"
          tabindex="0"
          @click="goTo('<')">
          <arrowhead-icon class="arrowhead-icon" />
        </button>
        <button
          class="banner-list__controls-item"
          tabindex="0"
          @click="goTo('>')">
          <arrowhead-icon class="arrowhead-icon" />
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import Glide from '@glidejs/glide';
import ArrowheadIcon from 'Components/ui/Icons/ArrowheadIcon.vue';

export default {
  name: 'GameBannerList',

  components: {
    ArrowheadIcon,
  },

  props: {
    banners: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      glide: null,
      sliderIndex: 0,
    };
  },

  computed: {
    isSingle() {
      return this.banners.length === 1;
    },

    isEmpty() {
      return this.banners.length === 0;
    },
  },

  watch: {
    banners() {
      this.destroyGlide();
      this.$nextTick(() => this.initGlide());
    },
  },

  mounted() {
    this.$nextTick(() => this.initGlide());
  },

  methods: {
    initGlide() {
      if (this.isSingle) {
        return;
      }

      this.glide = new Glide('.glide-container', {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        gap: 10,
        swipeThreshold: false,
        dragThreshold: false,
        focusAt: 'center',
        autoplay: 5000,
        breakpoints: {
          1024: {
            swipeThreshold: true,
            dragThreshold: true,
          },
        },
      }).mount();

      this.glide.on('run', () => {
        this.sliderIndex = this.glide.index;
      });
    },

    destroyGlide() {
      if (this.glide) {
        this.glide.destroy();
        this.glide = null;
      }
    },

    goTo(direction) {
      this.glide?.go?.(direction);
    },
  },
};
</script>

<style lang="scss" scoped>
  .banner-list {
    position: relative;
    margin-bottom: 8px;
  }

  .banner-list__item {
    position: relative;
  }

  .banner-list__item-img {
    width: 100%;
    height: 176px;
    object-fit: cover;
  }

  .banner-list__controls {
    display: none;
    justify-content: space-between;
    width: 95px;
    position: absolute;
    top: 39px;
    right: calc(24px + var(--padding));
  }

  .banner-list__controls-item {
    --size: 2px;

    width: 40px;
    height: 40px;
    border-radius: 50px;
    transform: rotate(90deg);
    border: 1px solid $color--basic-dark-gray;
    background-color: transparent;
    transition: border-color 0.25s ease;

    &:last-child {
      transform: rotate(-90deg);
    }

    &:hover {
      border-color: $color--basic-white;
    }
  }

  .arrowhead-icon {
    --width: 30%;
  }

  .banner-list__bullets {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -4px;
    transform: translateX(-50%);
  }

  .banner-list__bullets-item {
    width: 8px;
    height: 8px;
    padding: 0;
    border-radius: 50px;
    background-color: transparent;
    border: 1px solid $color--basic-white;

    &--active {
      background-color: $color--basic-white;
    }

    &:not(:last-child) {
      margin-right: 8px;
    }
  }

  @media screen and #{$screen-less-than-768} {
    .banner-list__item-img {
      border-radius: 16px;
    }
  }

  @media screen and #{$screen-more-or-768} {
    .banner-list__item-img {
      height: 350px;
      border-radius: 10px;
    }

    .banner-list__bullets {
      display: none;
    }

    .banner-list__controls {
      display: flex;
    }
  }

  @media screen and (min-width: 1600px) {
    .banner-list__item-img {
      height: 450px;
    }
  }
</style>
